import channelParser from './parsers/channel';
import parseError from './parsers/error';

import parseUrl from './parse-url';

import urlTypes from './url-types';

import * as http from '../../utils/http';


const defaultPaging = {
  cursor: null,
};

const defaultSort = {
  order: 'relevance',
};

// split by 50 ids per request
const MAX_IDS_IN_REQUEST = 50;


export default function (settings, adapterMethods) {

  const parseChannel = _.partial(channelParser, urlTypes.CHANNEL);


  function _getChannelFirstVideoCover(uploadsPlaylistId, options = {}) {
    return adapterMethods.videos.getByPlaylistId(uploadsPlaylistId, {
        ...options,
        noVideoData: true,
        paging: {
          size: 1,
        },
      })
      .then(_.property('data[0].coverUrl'));
  }


  function getByUrl(url) {
    return parseUrl(url, true)
      .then(function ({ id, type }) {
        switch (type) {
          case urlTypes.CHANNEL:
            return get(id);

          case urlTypes.PLAYLIST:
            return adapterMethods.playlists.get(id);

          case urlTypes.USER_NAME:
            return getByUsername(id);

          default:
            return null;
        }
      })
      .catch(parseError);
  }


  function get(channelIds, options = {}) {

    channelIds = _.castArray(channelIds);

    if (!channelIds.length) {
      return Promise.resolve({
        status: 200,
        data: [],
      });
    }

    const { noExtraChannelData = false } = options;

    const channelRequests = _(channelIds)
      .uniq()
      .chunk(MAX_IDS_IN_REQUEST)
      .map(function (chunkChannelIds) {
        const params = {
          id: chunkChannelIds.join(','),
        };
        return http.get(`${settings.apiUrl}/channels`, { params });
      })
      .value();

    return Promise.all(channelRequests)
      .then(function (responses) {
        const channels = _.flatMap(responses, 'data.items');

        let parsedChannels = _.map(channels, parseChannel);

        if (noExtraChannelData) {
          return {
            status: responses[0].status,
            data: parsedChannels,
          };
        }

        const parsedChannelIds = _.map(parsedChannels, 'externalId');

        const missingIds = _.difference(channelIds, parsedChannelIds);
        const channelsWithoutCover = _.reject(parsedChannels, 'coverUrl');

        const missingChannels = _.map(missingIds, id => parseChannel({ id, isExternalRemoved: true }));

        return Promise.all(_.map(channelsWithoutCover, function ({ uploadsPlaylistId }) {
            return _getChannelFirstVideoCover(uploadsPlaylistId, options);
          }))
          .then(function (videoCovers) {
            const coverUrlByChannelId = _.zipObject(
              _.map(channelsWithoutCover, 'externalId'),
              videoCovers,
            );

            parsedChannels = _.map(parsedChannels, function (parsedChannel) {
              const { externalId, coverUrl } = parsedChannel;
              return {
                ...parsedChannel,
                coverUrl: coverUrlByChannelId[externalId] || coverUrl || null,
              };
            });

            return {
              status: responses[0].status,
              data: [
                ...parsedChannels,
                ...missingChannels,
              ],
            };
          });
      })
      .catch(parseError);
  }

  function getByUsername(forUsername, options = {}) {
    const params = {
      forUsername,
    };

    return http.get(`${settings.apiUrl}/channels`, { params })
      .then(function (response) {
        return {
          status: response.status,
          data: _.map(response.data.items, parseChannel),
        };
      })
      .then(function (response) {
        const channelData = response.data[0];

        const { coverUrl } = channelData;

        if (coverUrl) {
          return response;
        }

        return _getChannelFirstVideoCover(channelData.uploadsPlaylistId, options)
          .then(function (coverUrl) {
            return {
              ...response,
              data: [{
                ...channelData,
                coverUrl,
              }],
            };
          });
      })
      .catch(parseError);
  }


  function list(searchParams = {}, options = {}) {
    const sort = _.merge({}, defaultSort, options.sort);
    const paging = _.merge({}, defaultPaging, options.paging);

    const params = {
      pageToken: paging.cursor,
      order: sort.order,
      maxResults: MAX_IDS_IN_REQUEST,
      ...searchParams,
    };

    return http.get(`${settings.apiUrl}/channels`, { params })
      .then(function (response) {
        return {
          ...response,
          data: _.map(response.data.items, parseChannel),
        };
      })
      .catch(parseError);
  }


  return {
    get,
    getByUrl,
    getByUsername,
    list,
  };
}



// WEBPACK FOOTER //
// ./src/transport/adapters/youtube/channels.js